import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center bg-white"
      >
        <div className="text-zinc-500 text-sm uppercase tracking-[0.2em]">Loading</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
